module.exports = __webpack_public_path__ + "static/media/background-opacityTransition4.b72c9fa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/background-opacityTransition4.png
// module id = 2267
// module chunks = 0